import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import parse from 'html-react-parser';

import { IProviderDetailsPage } from './ProviderDetailsPage';
import {
	getProviderAboutSubTitleList,
	getProviderAboutTitle,
	getProviderEducationDetails,
	getProviderHireDate,
	getProviderLanguages,
} from './ProviderDetailsPage.helpers';
import {
	aboutListItemStyles,
	aboutListItemTitleStyles,
	aboutListStyles,
	aboutSubTitleListMiddotStyles,
	aboutSubTitleListStyles,
	getProviderContentContainerStyles,
	providerAboutSubTitleListBoxStyle,
	providerAboutTitleStyles,
} from './ProviderDetailsPage.styles';

export default function ProviderAbout({ provider, config }: IProviderDetailsPage) {
	const theme = useTheme();
	const isMobileScreen = useMediaQuery(theme.breakpoints.down('md'));
	const education = getProviderEducationDetails(provider);
	const hireDate = getProviderHireDate(provider);
	const languages = getProviderLanguages(provider);
	const listData = [
		{
			id: 'experience',
			title: 'Experience',
			value: '', // TODO: need to add later
		},
		{
			id: 'dental_education',
			title: 'Dental education',
			value: education,
		},
		{
			id: 'with_us_since',
			title: `With ${config.name} since`,
			value: hireDate,
		},
		{
			id: 'languages',
			title: 'Languages',
			value: languages,
		},
	];

	const providerAboutSubTitleList = getProviderAboutSubTitleList(provider, config);
	const biography = provider.biography || 'Biography Coming Soon';

	return (
		<Box data-testid="provider_about_container" sx={getProviderContentContainerStyles}>
			<Box data-testid="provider_about_title_sub_title_container">
				<Typography
					variant="header1"
					color="text.primary"
					component="h2"
					data-testid="provider_about_title"
					sx={providerAboutTitleStyles}
				>
					{getProviderAboutTitle(provider)}
				</Typography>
				<Box data-testid="provider_about_sub_title_container" sx={aboutSubTitleListStyles}>
					{providerAboutSubTitleList.map(({ value }, index) => {
						if (value && value !== '') {
							return (
								<Box key={index} sx={providerAboutSubTitleListBoxStyle}>
									{index !== 0 && (
										<Typography
											variant={isMobileScreen ? 'bodyMediumSemiBold' : 'bodyLargeSemiBold'}
											color="text.secondary"
											component="p"
											sx={aboutSubTitleListMiddotStyles}
										>
											&middot;
										</Typography>
									)}
									<Typography
										variant={isMobileScreen ? 'bodyMediumSemiBold' : 'bodyLargeSemiBold'}
										color="text.secondary"
										component="p"
										data-testid="provider_about_sub_title"
									>
										{value}
									</Typography>
								</Box>
							);
						}
					})}
				</Box>
				<Typography
					data-testid="provider_about_biography"
					variant={isMobileScreen ? 'bodyMediumBook' : 'bodyLargeBook'}
					color="text.secondary"
					component="p"
				>
					{parse(biography)}
				</Typography>
			</Box>
			<Box data-testid="provider_about_list_container" sx={aboutListStyles}>
				{listData.map(({ title, value, id }) => {
					if (value) {
						return (
							<Box key={title} sx={aboutListItemStyles}>
								<Typography
									data-testid={`provider_about_list_${id}_title`}
									variant={isMobileScreen ? 'bodyMediumBold' : 'bodyLargeBold'}
									color="text.primary"
									component="b"
									sx={aboutListItemTitleStyles}
								>
									{title}:
								</Typography>
								<Typography
									data-testid={`provider_about_list_${id}_value`}
									variant={isMobileScreen ? 'bodyMediumBook' : 'bodyLargeBook'}
									color="text.secondary"
									component="p"
								>
									{value}
								</Typography>
							</Box>
						);
					}
				})}
			</Box>
		</Box>
	);
}
